document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const hidden = root.querySelector('[data-variant-input]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-product-compare]');
    const unitPrice = root.querySelector('[data-unit-price]');
    const unitPriceRow = unitPrice?.closest('.ma-unit-price');
    const form = root.querySelector('[data-product-form]');
    const addButton = root.querySelector('[data-add-button]');
    const error = root.querySelector('[data-product-error]');
    const sticky = root.querySelector('[data-sticky-buy]');
    const stickySubmit = root.querySelector('[data-sticky-submit]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const stickyImage = root.querySelector('[data-sticky-image]');

    const pauseInactiveMedia = (activeId) => {
      root.querySelectorAll('[data-product-media]').forEach((media) => {
        if (String(media.dataset.mediaId) !== String(activeId)) {
          media.querySelectorAll('video').forEach((video) => video.pause());
          media.querySelectorAll('iframe').forEach((frame) => {
            try { frame.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo' }), '*'); } catch (_) {}
          });
        }
      });
    };

    const showMedia = (mediaId) => {
      if (!mediaId) return;
      let found = false;
      root.querySelectorAll('[data-product-media]').forEach((media) => {
        const active = String(media.dataset.mediaId) === String(mediaId);
        media.hidden = !active;
        media.classList.toggle('is-active', active);
        if (active) found = true;
      });
      root.querySelectorAll('[data-media-thumb]').forEach((thumb) => {
        const active = String(thumb.dataset.mediaId) === String(mediaId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (found) pauseInactiveMedia(mediaId);
    };

    const selectCard = (card) => {
      const input = card.querySelector('input');
      if (!input || input.disabled) return;
      root.querySelectorAll('[data-variant-card]').forEach((node) => node.classList.remove('is-selected'));
      card.classList.add('is-selected');
      input.checked = true;
      if (hidden) hidden.value = card.dataset.variantId;
      if (price) price.textContent = card.dataset.price || '';
      if (stickyPrice) stickyPrice.textContent = card.dataset.price || '';
      if (compare) compare.innerHTML = card.dataset.compare ? `<s>${card.dataset.compare}</s>` : '';
      const units = Number(card.dataset.units || 0);
      if (unitPrice && unitPriceRow) {
        unitPrice.textContent = card.dataset.unitPrice || '';
        unitPriceRow.hidden = units <= 1;
      }
      if (card.dataset.mediaId) showMedia(card.dataset.mediaId);
      if (stickyImage && card.dataset.image) stickyImage.src = card.dataset.image;
      const available = card.dataset.available === 'true';
      if (addButton) { addButton.disabled = !available; addButton.textContent = available ? 'Agregar al carrito' : 'Agotado'; }
      if (stickySubmit) { stickySubmit.disabled = !available; stickySubmit.textContent = available ? 'Comprar' : 'Agotado'; }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', card.dataset.variantId);
      history.replaceState({}, '', url);
    };

    root.querySelectorAll('[data-variant-card]').forEach((card) => {
      card.addEventListener('click', () => selectCard(card));
      card.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); selectCard(card); }
      });
    });

    root.querySelectorAll('[data-media-thumb]').forEach((button) => {
      button.addEventListener('click', () => showMedia(button.dataset.mediaId));
    });

    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      const quantity = form?.querySelector('[name="quantity"]');
      if (quantity) quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
    });
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      const quantity = form?.querySelector('[name="quantity"]');
      if (quantity) quantity.value = Number(quantity.value || 1) + 1;
    });

    stickySubmit?.addEventListener('click', () => {
      form?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => addButton?.focus(), 450);
    });

    if (sticky && form && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { rootMargin: '-90px 0px 0px 0px' });
      observer.observe(form);
    }

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const original = addButton?.textContent || 'Agregar al carrito';
      if (addButton) { addButton.disabled = true; addButton.textContent = 'Agregando…'; }
      if (stickySubmit) stickySubmit.disabled = true;
      if (error) { error.hidden = true; error.textContent = ''; }
      try {
        const rootPath = String(window.maritaTheme?.root || '/').replace(/\/?$/, '/');
        const response = await fetch(`${rootPath}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) { const payload = await response.json(); throw new Error(payload.description || 'No pudimos agregar el producto.'); }
        if (addButton) addButton.textContent = 'Agregado ✓';
        if (stickySubmit) stickySubmit.textContent = 'Agregado ✓';
        if (window.maritaStorefront) await window.maritaStorefront.openCart();
        else document.querySelector('[data-cart-open]')?.click();
      } catch (exception) {
        if (error) { error.textContent = exception.message || 'No pudimos agregar el producto.'; error.hidden = false; }
        if (addButton) addButton.textContent = 'Reintentar';
        if (stickySubmit) stickySubmit.textContent = 'Reintentar';
      } finally {
        window.setTimeout(() => {
          if (addButton) { addButton.disabled = false; addButton.textContent = original; }
          if (stickySubmit) { stickySubmit.disabled = false; stickySubmit.textContent = 'Comprar'; }
        }, 1600);
      }
    });
  });
});
